import { css } from '@emotion/core';
import { reflowStyles } from '../tabItem/component.styles';

const smallViewportStyles = {
  divider: ({ isUnderlined }) => `
    & {
      margin-top: -1px !important;
    }
    @media (max-width: 320px) {
      ${isUnderlined && 'display: none !important;'}
    }
  `,
  tab: `
    @media (max-width: 320px) {
      width: 100%;
      justify-content: left;
      flex-wrap: nowrap !important;

      &.cybs-tabItem-collapsed span.tabItem-visible-label {
        display: inline;
        text-align: left;
        min-width: calc(100% - 4rem);
      }
    }
  `,
  tabItem: ({ isUnderlined, theme }) => `
    @media (max-width: 320px) {
      width: 100%;
    }
  `,
  selected: ({ theme }) => `
    @media (max-width: 320px) {
      &:not(.vds-state--disabled){
        box-shadow: inset 4px 0 ${theme?.cybs?.core?.primary?? '#1434CB'};
      }
      &:not(:hover, :focus, .vds-state--disabled) {
        border-top: 1px solid ${theme?.cybs?.base?.wcag21?.stoneGrey?? '#62798D'};
        border-bottom: 1px solid ${theme?.cybs?.base?.wcag21?.stoneGrey?? '#62798D'};
      }
    } 
  `
};

const styles = ({ isUnderlined, theme }) => ({
  base: css`
    & .vds-tab-item {
      display: inline-block !important;

      & .vds-tab {
        &.vds-tab:active, &.vds-state--selected {
          ${smallViewportStyles.selected({ theme })}
        }

        ${reflowStyles.default}
        ${smallViewportStyles.tab}
      }
      
      & button:focus {
        z-index: 1;
      }

      ${smallViewportStyles.tabItem({ isUnderlined, theme })}
    }

    & hr {
      ${smallViewportStyles.divider({ isUnderlined })}
    }

    & > div:last-child {
      margin-top: 1.25rem;

      &:empty {
        margin-top: 0;
      }
    }
  `
});

export default styles;
